'use strict';

const UIStateStore = require('stores/UIStateStore'),
    {t} = require('services/i18nextWrapper'),
    AppActionCreators = require('actions/AppActionCreators'),
    Constants = require('constants/AppConstants'),
    ActionTypes = Constants.ActionTypes,
    RestUtils = require('utils/RestUtils'),
    Security = require('services/Security').auth,
    ContentUtils = require('utils/ContentUtils'),
    BrowserUtils = require('utils/BrowserUtils'),
    EventEmitter = require('events').EventEmitter,
    hostApi = process.env.URL_API,
    assign = require('object-assign'),
    UserServiceImpl = require('services/UserServiceImpl'),
    LocaleServiceImpl = require('services/LocaleServiceImpl'),
    SessionActionCreators = require('actions/SessionActionCreators'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    SchedulerAppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
    get = require('lodash/object').get,
    UserPermissionStore = require('stores/UserPermissionStore'),
    {find, filter, map, some} = require('lodash/collection'),
    CHANGE_EVENT = 'emit',
    KEY_IS_VISIBLE_BREWING_SECTION = 'cache_is_visible_brewing_section',
    KEY_IS_VISIBLE_FERMENTING_SECTION = 'cache_is_visible_fermenting_section',
    KEY_IS_VISIBLE_PACKAGING_SECTION = 'cache_is_visible_packaging_section',
    KEY_IS_VISIBLE_BEER_STYLE_LABEL_BREWING = 'cache_is_visible_beer_style_label_brewing',
    KEY_IS_VISIBLE_BEER_STYLE_LABEL_FERMENTING = 'cache_is_visible_beer_style_label_fermenting',
    KEY_IS_VISIBLE_BEER_STYLE_LABEL_PACKAGING = 'cache_is_visible_beer_style_label_packaging',
    KEY_APPLICANT_USER_LOGGED = 'cache_applicant_user_logged',
    KEY_LAST_BATCH_NUMBER = 'cache_last_batch_number',
    KEY_APPLICANT_LICENSE = 'cache_applicant_license',
    KEY_HAS_PENDING_DRAFT_WITHOUT_PUBLISH = 'cache_has_pending_draft_without_publish',
    KEY_APPLICANT_PHONE = 'cache_applicant_phone',
    KEY_APPLICANT_EMAIL = 'cache_applicant_email',
    KEY_ROLES_USER_LOGGED = 'cache_roles_user_logged',
    KEY_CURRENCY = 'cache_current_currency',
    KEY_CURRENCY_DIGITS = 'cache_current_currency_digits',
    KEY_LOCATION = 'cache_current_locator',
    KEY_TIME_ZONE = 'cache_current_timezone',
    KEY_COUNTRY = 'cache_current_country',
    KEY_CREATED_DATE = 'created_date',
    KEY_IS_CALCULATING_INVENTORY_ENABLED = 'cache_is_calculating_inventory_enable',
    KEY_CURRENCY_CONVERTER = 'cache_current_currency_converter',
    KEY_COUNTRY_NAME = 'cache_current_country_name',
    KEY_APPLICANT_DISPLAY_NAME = 'cache_applicant_display_name',
    KEY_APPLICANT_ID = 'cache_applicant_id',
    KEY_APPLICANT_ADDRESS = 'cache_applicant_address',
    KEY_APPLICANT_TAX_ID = 'cache_applicant_city_tax_id',
    KEY_APPLICANT_CITY_AND_STATE = 'cache_applicant_city_and_state',
    KEY_USER_NAME = 'cache_user_name',
    KEY_PERMISSIONS = 'cache_permissions',
    KEY_USER_PERMISSIONS = 'cache_user_permissions',
    KEY_LANGUAGE = 'cache_current_language',
    KEY_MAX_INVENTORY_SCOPE_DATE = 'cache_max_inventory_scope_date';


const PREFERRED_LANGUAGE = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage || 'en';

const SessionStore = assign({}, EventEmitter.prototype, {

    /**
     * The last number of publish version fetched from the server.
     *
     * NOTE: this are not store in the local store, in order to sync between
     * different windows in the same browser in the same applicant. The same for lastBrewingNoteNumber version.
     */
    lastPublishVersion: -1,
    _isUserTaskFetching: true,

    /**
     * The last number of note version fetched from the server.
     */
    lastBrewingNoteNumber: -1,

    /**
     * The last number of note version fetched from the server.
     */
    lastPackagingNoteNumber: -1,

    /**
     * A list of information which each countries.
     */
    countries: [],

    /**
     * A list of information of currencies.
     */
    currencies: [],

    /**
     * Return the current app version.
     * @returns {Number}
     */
    getCurrentAppVersion() {
        return ContentUtils.getSession(Constants.APP_VERSION_KEY);
    },

    setDefaultLenguage(){
        ContentUtils.saveSession(Constants.DEFAULT_LANGUAGE);
    },

    setPreferredLenguage() {
        ContentUtils.saveSession(PREFERRED_LANGUAGE);
    },

    setMaxScopeInventoryDate(date) {
       ContentUtils.saveSession(KEY_MAX_INVENTORY_SCOPE_DATE, date);
    },

    getMaxScopeInventoryDate() {
        return ContentUtils.getSession(KEY_MAX_INVENTORY_SCOPE_DATE);
    },

    /**
     * Update current app version.
     * @param version
     */
    setCurrentAppVersion(version) {
        ContentUtils.saveSession(Constants.APP_VERSION_KEY, version);
    },

    /**
     * Retrieve the last number of publish order version fetched from the server.
     */
    getLastPublishVersion() {
        return this.lastPublishVersion;
    },

    /**
     * Assign the new last published version.
     * @param newVersion
     */
    setLastPublishVersion(newVersion) {
        this.lastPublishVersion = newVersion;
    },

    /**
     * Retrieve the last brewing number of note version fetched from the server.
     */
    getLastBrewingNoteNumber() {
        return this.lastBrewingNoteNumber;
    },

    /**
     * Assign the new last published version.
     * @param newVersion
     */
    setLastPublicationAdminNumber: function (newVersion) {
        this.lastPublicationAdminNumber = newVersion;
    },

    /**
     * Retrieve the last brewing number of note version fetched from the server.
     */
    getLastChangeUserToken: function () {
        return this.lastChangeUserToken;
    },
    /**
     * Assign the new last published version.
     * @param newVersion
     */
    setLastChangeUserToken: function (newVersion) {
        this.lastChangeUserToken = newVersion;
    },

    /**
     * Retrieve the last brewing number of note version fetched from the server.
     */
    getLastPublicationAdminNumber: function () {
        return this.lastPublicationAdminNumber;
    },

    /**
     * Assign the new last brewing note version.
     * @param newVersion
     */
    setLastBrewingNoteNumber(newVersion) {
        this.lastBrewingNoteNumber = newVersion;
    },

    /**
     * Retrieve the last oackaging number of note version fetched from the server.
     */
    getLastPackagingNoteNumber() {
        return this.lastPackagingNoteNumber;
    },

    /**
     * Assign the new last packaging note version.
     * @param newVersion
     */
    setLastPackagingNoteNumber(newVersion) {
        this.lastPackagingNoteNumber = newVersion;
    },

    emitChange() {
        this.emit(CHANGE_EVENT);
    },

    removeChangeListener(call) {
        this.removeListener(CHANGE_EVENT, call);
    },

    addChangeListener(call) {
        this.on(CHANGE_EVENT, call);
    },

    setCurrentUserRoles(roles) {
        ContentUtils.saveSession(KEY_ROLES_USER_LOGGED, roles);
    },

    setCurrentCurrency(currency) {
        ContentUtils.saveLocal(KEY_CURRENCY, currency);
    },

    setCurrentCurrencyDigits(digits) {
        ContentUtils.saveLocal(KEY_CURRENCY_DIGITS, digits);
    },

    setHasPendingSavedDraftWithoutPublish(hasPublish) {
        ContentUtils.saveSession(KEY_HAS_PENDING_DRAFT_WITHOUT_PUBLISH, hasPublish);
    },

    getHasPendingSavedDraftWithoutPublish() {
        return ContentUtils.getSession(KEY_HAS_PENDING_DRAFT_WITHOUT_PUBLISH);
    },
    
    setUserTaskFetching(isUserTaskFetching) {
        this._isUserTaskFetching = isUserTaskFetching;
    },
    
    setUserTaskDate(date) {
      this._userTaskDate = date;
    },
    
    getUserTaskDate() {
      return this._userTaskDate;
    },
    
    isUserTaskFetching() {
        return this._isUserTaskFetching;
    },

    getCurrentCurrency() {
        return ContentUtils.getLocal(KEY_CURRENCY);
    },

    getCurrentCurrencyDigits() {
        return ContentUtils.getLocal(KEY_CURRENCY_DIGITS);
    },

    setCurrentCurrencyConverter(currency) {
        ContentUtils.saveSession(KEY_CURRENCY_CONVERTER, currency);
    },

    getCurrentCurrencyConverter() {
        return ContentUtils.getSession(KEY_CURRENCY_CONVERTER);
    },

    setCurrentLocation(location) {
        ContentUtils.saveSession(KEY_LOCATION, location);
    },

    setLastBatchNumber(batchNumber) {
        ContentUtils.saveSession(KEY_LAST_BATCH_NUMBER, batchNumber);
    },

    getLastBatchNumber() {
        return ContentUtils.getSession(KEY_LAST_BATCH_NUMBER);
    },

    getCurrentLocation() {
        return ContentUtils.getSession(KEY_LOCATION) || PREFERRED_LANGUAGE;
    },

    setCurrentTimezone(location) {
        ContentUtils.saveSession(KEY_TIME_ZONE, location);
    },

    getCurrentTimeZone() {
        return ContentUtils.getSession(KEY_TIME_ZONE);
    },

    setCurrentLanguage(language) {
        ContentUtils.saveLocal(KEY_LANGUAGE, language);
    },

    getCurrentLanguage() {
        return ContentUtils.getLocal(KEY_LANGUAGE);
    },

    setCurrentLicense(license) {
        ContentUtils.saveSession(KEY_APPLICANT_LICENSE, license);
    },

    getCurrentLicense() {
      return ContentUtils.getSession(KEY_APPLICANT_LICENSE);
    },

    setCreatedDate(createdDate) {
        ContentUtils.saveSession(KEY_CREATED_DATE, createdDate);
    },

    getCreatedDate() {
        return ContentUtils.getSession(KEY_CREATED_DATE);
    },

    setApplicantDisplayName(name) {
        ContentUtils.saveSession(KEY_APPLICANT_DISPLAY_NAME, name);
    },

    getApplicantDisplayName() {
      const displayName = ContentUtils.getSession(KEY_APPLICANT_DISPLAY_NAME);
      if (!displayName) {
          return  Security.getCurrentApplicant();
      } else {
         return displayName;
      }
    },

    getCurrentCountry() {
        return ContentUtils.getSession(KEY_COUNTRY);
    },

    setCurrentCountry(location) {
        ContentUtils.saveSession(KEY_COUNTRY, location);
    },

    setCurrentCountryName(location) {
        ContentUtils.saveSession(KEY_COUNTRY_NAME, location);
    },

    getCurrentCountryName() {
        return ContentUtils.getSession(KEY_COUNTRY_NAME);
    },

    setCurrentApplicant(applicant) {
        ContentUtils.saveSession(KEY_APPLICANT_USER_LOGGED, applicant);
    },

    setIsCalculatingInventory(isCalculatingInventoryEnabled) {
        ContentUtils.saveLocal(KEY_IS_CALCULATING_INVENTORY_ENABLED, isCalculatingInventoryEnabled);
    },

    isCalculatingInventory() {
        return ContentUtils.getLocal(KEY_IS_CALCULATING_INVENTORY_ENABLED);
    },

    getCurrentUserRoles() {
        return ContentUtils.getSession(KEY_ROLES_USER_LOGGED);
    },

    getCurrentApplicant() {
        return ContentUtils.getSession(KEY_APPLICANT_USER_LOGGED);
    },

    getApplicantAddress() {
        return ContentUtils.getSession(KEY_APPLICANT_ADDRESS);
    },
    
    isVisibleBrewingSection() {
        return ContentUtils.getLocal(KEY_IS_VISIBLE_BREWING_SECTION);
    },
    
    setIsVisibleBrewingSection(value) {
      ContentUtils.saveLocal(KEY_IS_VISIBLE_BREWING_SECTION, value);
    },
    
    isVisibleFermentingSection() {
        return ContentUtils.getLocal(KEY_IS_VISIBLE_FERMENTING_SECTION);
    },
    
    setIsVisibleFermentingSection(value) {
      ContentUtils.saveLocal(KEY_IS_VISIBLE_FERMENTING_SECTION, value);
    },
    
    isVisiblePackagingSection() {
        return ContentUtils.getLocal(KEY_IS_VISIBLE_PACKAGING_SECTION);
    },
    
    setIsVisiblePackagingSection(value) {
      ContentUtils.saveLocal(KEY_IS_VISIBLE_PACKAGING_SECTION, value);
    },
    
    isVisibleBeerStyleLabelBrewing() {
        return ContentUtils.getLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_BREWING);
    },
    
    setIsVisibleBeerStyleLabelBrewing(value) {
      ContentUtils.saveLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_BREWING, value);
    },
    
    isVisibleBeerStyleLabelFermenting() {
      return ContentUtils.getLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_FERMENTING);
    },
    
    setIsVisibleBeerStyleLabelFermenting(value) {
      ContentUtils.saveLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_FERMENTING, value);
    },
    
    isVisibleBeerStyleLabelPackaging() {
      return ContentUtils.getLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_PACKAGING);
    },
    
    setIsVisibleBeerStyleLabelPackaging(value) {
      ContentUtils.saveLocal(KEY_IS_VISIBLE_BEER_STYLE_LABEL_PACKAGING, value);
    },

    setApplicantAddress(address) {
        ContentUtils.saveSession(KEY_APPLICANT_ADDRESS, address);
    },

    setApplicantCityAndState(address) {
        ContentUtils.saveSession(KEY_APPLICANT_CITY_AND_STATE, address);
    },

    setApplicantTaxId(taxId) {
        ContentUtils.saveSession(KEY_APPLICANT_TAX_ID, taxId);
    },

    getApplicantTaxId() {
        return ContentUtils.getSession(KEY_APPLICANT_TAX_ID);
    },

    getApplicantCityAndState() {
        return ContentUtils.getSession(KEY_APPLICANT_CITY_AND_STATE);
    },

    getApplicantPhone() {
        return ContentUtils.getSession(KEY_APPLICANT_PHONE);
    },

    setApplicantPhone(applicantPhone) {
        ContentUtils.saveSession(KEY_APPLICANT_PHONE, applicantPhone);
    },

    getApplicantEmail() {
        return ContentUtils.getSession(KEY_APPLICANT_EMAIL);
    },

    setApplicantEmail(email) {
        ContentUtils.saveSession(KEY_APPLICANT_EMAIL, email);
    },

    getAccountAgeDays() {
        const createdDate = new Date(this.getCreatedDate());
        const currentDate = new Date();

        return ((currentDate - createdDate)/1000/60/60/24);
    },

    // This function is a legacy function to determine what features the user has access to.
    // For now, we set it all to true no matter what the user is, because we will gate access
    // based on trial version and time frame.
    isFullPaidVersion() {
        const isTrialActive = this.isTrialVersionActive();
        return this.getCurrentLicense() === Constants.LICENSE_FULL_VERSION
            || (
                (this.isTrialVersion() && isTrialActive)
                || (this.isBasePaidVersion && isTrialActive)
            );
    },

    isPaidVersion() {
        return this.isFullPaidVersion() || this.isBasePaidVersion() || (this.isTrialVersion() && this.isTrialVersionActive());
    },

    isTrialVersionActive() {
        return (this.getAccountAgeDays() < 14);
    },

    isTrialVersion() {
        return this.getCurrentLicense() === Constants.LICENSE_TRIAL_FULL_VERSION;
    },

    isBasePaidVersion() {
        return this.getCurrentLicense() === Constants.LICENSE_FREE_VERSION;
    },

    /**
     * Retrieve if the current user logged is an adming user.
     * @return {Boolean}
     */
    isAdminUser() {
        if (BrowserUtils.isMobileNonIPad()) {
            return false;
        }
    
        return this.isAbleToEditDates() || this.isAbleToEditAllWithoutDates();
    },
    
    hasAdminUserPermission() {
        return [].some.call(this.getCurrentUserRoles(), function (role) {
            return role === Constants.ROLE_ADMIN;
        });
    },

    fetchUserInformationAndSaveIfNeeded(onFinish) {
        try {
            const isUserLogged = !!Security.getCurrentApplicantId();
            const self = this;
            if (isUserLogged) {

                // fetching first all permissions related of current user logged
                this.fetchPermissions();

                LocaleServiceImpl.getApplicantSetting(function () {
                    // enter here means the server not have yet the
                    // configuration so we need to infer it.
                    const isEmptyResponse = !!this.response === false;

                    if (isEmptyResponse) {
                        // enter here means the user is loggin but don't have applicant configuration
                        // so we need to save one
                        self.inferUserInformation(() => {
                            LocaleServiceImpl.saveSettingModal(self.getUserSettings.bind(self)());
                        });
                    } else {
                        self.fillApplicantInformation(ContentUtils.parse(this.response));
                    }

                    if (onFinish) {
                        onFinish();
                    }
                });
            } else {
                // the user is not loggin yet
                this.inferUserInformation(onFinish);
            }
        } catch(error) {
            console.info('Error when try to fetch user information: ' + error);
        }
    },

    fetchUserInfoWithoutTriggerAction(onFinish) {
        const isUserLogged = !!Security.getCurrentApplicantId();
        const self = this;
        if (isUserLogged) {
            // fetching first all permissions related of current user logged
            LocaleServiceImpl.getApplicantSetting(function () {
                // enter here means the server not have yet the
                // configuration so we need to infer it.
                const isEmptyResponse = !!this.response === false;

                if (isEmptyResponse) {
                    // enter here means the user is loggin but don't have applicant configuration
                    // so we need to save one
                    self.inferUserInformation(() => {
                        LocaleServiceImpl.saveSettingModal(self.getUserSettings.bind(self)());
                    });
                } else {
                    self.fillApplicantInformation(ContentUtils.parse(this.response));
                }

                if (onFinish) {
                    onFinish();
                }
            });
        }
    },

    fetchPermissions() {
        SessionActionCreators.permissionRequestUpdate(
            ContentUtils.getSession('userNameSession'),
            ContentUtils.getSession('X-Auth-Token'),
            Security.getCurrentApplicantId()
        );
    },

    getUserSettings() {
        return {
            countryCode: get(this.getCurrentCountry(), 'cca3'),
            currencyCode: get(this.getCurrentCurrency(), 'code'),
            timeZone: this.getCurrentTimeZone(),
            locale: this.getCurrentLocation()
        };
    },

    onTogglePermission(permissionChanged) {
       const isOff = permissionChanged.isSelected === 'NO';
       permissionChanged.isChecked = isOff ? true : false;
       permissionChanged.isSelected = isOff ? 'YES' : 'NO';
       return permissionChanged;
    },
    
    forcePermission(permissionChanged, state) {
      permissionChanged.isChecked = state;
      permissionChanged.isSelected = state ? 'YES' : 'NO';
      return permissionChanged;
    },

    inferUserInformation(onSuccess) {
        this.currencies = require('currency-formatter').currencies;
        this.currencyDigits = require('../assets/data/digits.json');
        this.countries = require('assets/data/countries.json');

        const currentLanguage = ContentUtils.getLocal('cache_current_language');
        const currentCurrency = ContentUtils.getLocal('cache_current_currency');

        if (currentCurrency && currentLanguage) {
            // if user already have currency and language configured, do nothing.
            return;
        }
      
        // default user information
        this.setCurrentCountry('USA');
        this.setCurrentCountryName('United States');
        this.setCurrentTimezone('America/Denver');
        this.setCurrentCurrency('USD');
        this.setCurrentCurrencyConverter('1');
    
        let currentLocale = localStorage.getItem('i18nextLng') || navigator.language || navigator.userLanguage;
        if (currentLocale) {
            // remove ""
            currentLocale =  currentLocale ? currentLocale.replaceAll('\"', '') : '';
            currentLocale = currentLocale.indexOf('_') > -1
              ? currentLocale.substring(0, currentLocale.indexOf('_'))
              : currentLocale.substring(0, currentLocale.indexOf('-'))
              ? currentLocale.substring(0, currentLocale.indexOf('-'))
              : currentLocale;
        } else {
            currentLocale = 'en' ;
        }
        
        this.setCurrentLanguage(currentLocale);

        if (onSuccess) {
            onSuccess();
        }
    },

    fillApplicantInformation(applicantConfigurtionDetail) {
        this.currencies = require('currency-formatter').currencies;
        this.currencyDigits = require('../assets/data/digits.json');
        this.countries = require('assets/data/countries.json');

        // If Locale changes need to refresh
        if(this.getCurrentLanguage()!==get(applicantConfigurtionDetail, 'locale')){
            AppActionCreators.saveSettingModal();
        }

        const countryCode = get(applicantConfigurtionDetail, 'countryCode');
        const timeZone = get(applicantConfigurtionDetail, 'timeZone');
        const currencyCode = get(applicantConfigurtionDetail, 'currencyCode');
        const currencyDigits = get(applicantConfigurtionDetail, 'currencyDigits');
        const locale = get(applicantConfigurtionDetail, 'locale');
        const currencyInfo = find(this.currencies, currency => get(currency, 'code') === currencyCode);
        const currencyDigitsInfo = find(this.currencyDigits, digits => get(digits, 'value') === currencyDigits);
        const currentCountry = find(this.countries, country => get(country, 'cca2') === countryCode || get(country, 'cca3') === countryCode);
        const applicantLicense = get(applicantConfigurtionDetail, 'versionName');
        const applicantLogoSrc = get(applicantConfigurtionDetail, 'applicantLogoSrc');
        const applicantDisplayName = get(applicantConfigurtionDetail, 'applicantDisplayName');
        const applicantCreatedDate = get(applicantConfigurtionDetail, 'createdDate');

        // successfully user information inferred
        this.setCurrentCountry(currentCountry);
        this.setCurrentCountryName(get(currentCountry, 'name.common', ''));
        this.setCurrentCurrency(currencyInfo);
        this.setCurrentCurrencyDigits(currencyDigitsInfo);
        this.setCurrentTimezone(timeZone);
        this.setCurrentLanguage(locale);
        this.setCurrentLicense(applicantLicense);
        this.setApplicantDisplayName(applicantDisplayName);
        this.setCreatedDate(applicantCreatedDate);
        Security.setCurrentApplicantLogoSrc(applicantLogoSrc);
    },

    getInferredUserInformation() {
        return {
            countryCode: get(this.getCurrentCountry(), 'cca2'),
            timeZone: this.getCurrentTimeZone(),
            currencyCode: get(this.getCurrentCurrency(), 'code'),
            locale: this.getCurrentLanguage()
        };
    },

    getAllUsers(onSuccess, onFailure) {
        UserServiceImpl.getUsers(onSuccess, onFailure, Security.getToken(), Security.getCurrentApplicantId());
    },

    fetchUserAccess(onSuccess, onFailure){
        UserServiceImpl.getUsersAccess(onSuccess, onFailure, Security.getToken(), Security.getCurrentApplicantId());
    },

    fetchGDPRCompliance(texts, success, failure) {
        var ajax = RestUtils.createXHR();
        const self = this;
        
        if (!texts) {texts = {};}
        
        const {
            confirmationAccept,
            labelPrivacy,
            labelAnd,
            labelUserAgreement
        } = texts;
        
        const logout = function () {
            Security.logout();
        };
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
           const isNotFound = this.status === 404;
           if (isNotFound) {
               CustomDialog.showWarningConfirmation(
                   '',
                   `${confirmationAccept} <a target="_blank" href="https://www.brewplanner.com/privacy-policy">${labelPrivacy}</a> ${labelAnd} <a target="_blank" href="https://www.brewplanner.com/user-agreement">${labelUserAgreement}</a>.`,
                   function () {self.confirmGDPRCompliance();},
                   t('button_label_accept'),
                   t('button_label_reject'),
                   logout,
                   logout);
           }
        }) ;
        ajax.open('GET', hostApi + '/gdpr/' + Security.getCurrentApplicant());
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send();
    },

    confirmGDPRCompliance(success, failure) {
        const self = this;
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
        });
        ajax.open('POST', hostApi + '/gdpr/' + self.getCurrentApplicant() + '/confirm');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        ajax.send();
    },

    getSessionData() {
        return {
            loggedIn: Security.loggedIn(),
            isMessageDaysOpen: UIStateStore.isBrewingNotesBarOpen(),
            isBrewingNotesBarOpen: UIStateStore.isBrewingNotesBarOpen(),
            isPackagingNotesBarOpen: UIStateStore.isPackagingNotesBarOpen(),
            avatarImage: '/assets/images/brand.png',
            userDisplay: Security.getCurrentUserName(),
            staticBox: false
        };
    },

    getPermissions() {
        return ContentUtils.getSession(KEY_PERMISSIONS);
    },

    getUserPermissions() {
        return ContentUtils.getSession(KEY_USER_PERMISSIONS);
    },

    isAbleToChangeNotes() {
        return this.isAdminUser() ? true : some(this.getUserPermissions(), permission => get(permission, 'name') === 'DASHBOARD_EDIT_NOTES');
    },

    isAbleToEditDates() {
      return this.hasAdminUserPermission() ||
        some(this.getUserPermissions(), permission => get(permission, 'name') === 'DASHBOARD_EDIT_ALL');
    },
    
    isAbleToEditAllWithoutDates() {
      return this.hasAdminUserPermission() ||
        some(this.getUserPermissions(), permission => get(permission, 'name') === 'DASHBOARD_EDIT_ALL_WITHOUT_DATES');
    },
    
    setPermissions(permissions) {
        ContentUtils.saveSession(KEY_PERMISSIONS, permissions);
    },

    setUserPermissions(userPermissions) {
        ContentUtils.saveSession(KEY_USER_PERMISSIONS, userPermissions);
    },

    setApplicantId(applicantId) {
      ContentUtils.saveSession(KEY_APPLICANT_ID, applicantId);
    },

    getCurrentApplicantId() {
        return ContentUtils.getSession(KEY_APPLICANT_ID);
    },

    setUserName(userName) {
      ContentUtils.saveSession(KEY_USER_NAME, userName);
    },

    getHeaderHigh() {
        return Constants.HEADER_HIGHT;
    },

    updatePermission(userName, token, applicantId) {
        const self = this;
        UserPermissionStore.getUsersAccess(function (userInfo) {
            const userPermissionsByUser = filter(get(userInfo, 'userPermissions'), userPermission => get(userPermission, 'isEnable')) || [];
            const userPermissionFiltered = filter(userPermissionsByUser, userPermission => get(userPermission, 'user.username') === userName);
            const userPermissionsAllowed = map(userPermissionFiltered, userPermission => get(userPermission, 'permissions')) || [];

            const permissions = get(userInfo, 'permissions');
            const applicantVersion = get(userInfo, 'applicantVersion');
            UserPermissionStore.setPermissions(permissions);
            UserPermissionStore.setUserPermissions(userPermissionsAllowed);
            self.setCurrentLicense(applicantVersion);


            SessionActionCreators.permissionUpdated();
        }, () => {
            // code here when something goes wrong
        }, token, applicantId);
    }
});

SessionStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {

    switch (action.type) {
        case ActionTypes.LOGGED_IN:
            SessionStore.setApplicantId(action.applicantId);
            SessionStore.setUserName(action.userName);
            SessionStore.fetchGDPRCompliance(action.texts, () => {
                console.info('GDPR - Compliance success');
            });
            SessionStore.fetchUserInfoWithoutTriggerAction(() => {
                SessionStore.emitChange();
            });
            break;

        case ActionTypes.LOGGED_OUT:
            Security.logout();
            SessionStore.emitChange();
            break;
        case ActionTypes.PERMISSION_UPDATED: {
            SessionStore.emitChange();
            break;
        }
        case ActionTypes.PERMISSION_REQUEST_UPDATE: {
            SessionStore.updatePermission(action.userName, action.token, action.applicantId);
            break;
        }
        default:
    }

});

module.exports = SessionStore;



/** WEBPACK FOOTER **
 ** ./src/stores/SessionStore.js
 **/